//@ts-nocheck
import React, { useEffect, useState } from "react";

import {useRedux} from "../hooks";
import {
    copyActivity,
    dontSetReloadAfterAction,
    getPeerActivities, onUpdatePeerActivityItems, removeActivity, setEditPeerActivityItems,
    setNeedReloadPeerActivities, setShowMoreChannels, showPeerActivityEditModal
} from "../redux/Content/PeerActivity/actions";
import {getContentConnectors} from "../redux/Content/Connector/actions";
import {PeerActivityModeCode} from "../redux/Content/PeerActivityMode/types";
import {PeerActivityType} from "../redux/Content/PeerActivity/types";
import '../i18/config';
import {useTranslation} from "react-i18next";
import MonthPostsBoard from "./Calendar/MonthPostsBoard";
import WeekPostsBoard from "./Calendar/WeekPostsBoard";
import DayChannelBoard from "./Calendar/DayChannelBoard";
import {useCalendarPeriod} from "./Calendar/useCalendarPeriod";
import {ContentConnectorSocialCalendar} from "../redux/Content/Connector/types";
import {ContentPeerChannelType} from "../redux/Content/PeerChannel/types";
import {formatISO} from "date-fns/formatISO";
import {UTCDate} from "@date-fns/utc";
import {startOfWeek} from "date-fns";
import {onVariantGroupCreateRequest, useVariantGroups} from "./Calendar/useVariantGroups";
import {channelModes, textLimit} from "./Calendar/VariantGroupCard.helpers";
import VariantGroupModal from "../blocks/Content/VariantGroup/VariantGroupModal";
import {VariantGroupType} from "../redux/Content/VariantGroup/types";

interface InputCalendarProps {
  id: string;
  handleNewActivity: (eventDate?:number, mode?:string, targetChannelUuid?:string) => void
  toggleIdeasBlock: () => void;
}

const Calendar = ({ id, handleNewActivity, toggleIdeasBlock }: InputCalendarProps) => {

    const { t, i18n } = useTranslation(['common']);

    const { dispatch, useAppSelector } = useRedux();

    // Feature 007: the in-house period hook owns view + cursor + visible range (replaces FullCalendar).
    const period = useCalendarPeriod();

    const [activities, setActivities] = useState<PeerActivityType[]>([])
    const [ peerActivityIdeas, setPeerActivityIdeas] = useState<PeerActivityType[]>([]);

    // Feature 012: variant groups of the visible period, and the one open in the modal.
    const {groups: variantGroups} = useVariantGroups(new Date(period.range.start), new Date(period.range.end));
    const [openGroup, setOpenGroup] = useState<{uuid: string | null; createAt?: Date} | null>(null);
    useEffect(() => onVariantGroupCreateRequest(() => setOpenGroup({uuid: null, createAt: new Date(Date.now() + 86400000)})), []);
    const boardOpenGroup = (group: VariantGroupType) => setOpenGroup({uuid: group.uuid});

    const {
        contentConnectors,
        peerActivity,
        contentActivitiesFilter,
        peerActivityIdea,
        peerChannels,
        contentConnectorDataParam
    } = useAppSelector(state => ({
        contentConnectors: state.ContentConnector,
        peerActivity: state.PeerActivity,
        contentActivitiesFilter: state.ContentActivitiesFilter,
        peerActivityIdea: state.PeerActivityIdea,
        peerChannels: state.ContentPeerChannel,
        contentConnectorDataParam: state.ContentConnectorDataParam
    }));

    useEffect(() => {
        dispatch(getContentConnectors());
    }, [dispatch]);

    useEffect(()=>{
        if ( peerActivityIdea?.items &&  peerActivityIdea.items.length>0){
            setPeerActivityIdeas([...peerActivityIdea.items]);
        } else {
            setPeerActivityIdeas([]);
        }
    },[
        peerActivityIdea.items,
    ])

    // Fetch the posts for the visible range whenever the view or cursor moves.
    // Preserves the ms-epoch (startDate/endDate) contract the API expects.
    useEffect(() => {
        peerActivity.startDate = new UTCDate(period.range.start).setHours(0,0,0,0);
        peerActivity.endDate = new UTCDate(period.range.end).setHours(0,0,0,0);
        dispatch(getPeerActivities(peerActivity));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[period.range.start, period.range.end, period.viewId]);

    // Reload the visible range after an action flags isNeedReload.
    useEffect(()=>{
        if (peerActivity.isNeedReload){
            peerActivity.startDate = new UTCDate(period.range.start).setHours(0,0,0,0);
            peerActivity.endDate = new UTCDate(period.range.end).setHours(0,0,0,0);
            dispatch(getPeerActivities(peerActivity));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[peerActivity.isNeedReload]);

    useEffect(() => {

        if (peerActivity.items !== undefined) {

            (peerActivity.items || []).map((item:PeerActivityType)=>{
                if ((item.end === undefined) ||  (item.end === null)){
                    if (new Date(item.activeFrom).getHours()===23){
                        item.end = formatISO(new Date(item.activeFrom).setMinutes(59))
                    }
                }
                return item;
            })

            setActivities(peerActivity.items);
        } else {
            setActivities([]);
        }

        filterActivities();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[peerActivity?.items]);

    const filterActivities = () => {
        let filteredActivities = peerActivity.items;

        if (contentActivitiesFilter.modes !== undefined && contentActivitiesFilter.modes.length>0){
            filteredActivities = (filteredActivities || []).filter((item:PeerActivityType)=>{

                if (item.mode && item.mode.uuid.length>0){
                    return contentActivitiesFilter.modes.indexOf(item.mode.uuid) === -1
                }
                return true;

            })
        }
        if (contentActivitiesFilter.types !== undefined && contentActivitiesFilter.types.length>0){
            filteredActivities = (filteredActivities || []).filter((item:PeerActivityType)=>{

                if (item.type && item.type.uuid.length>0){
                    return contentActivitiesFilter.types.indexOf(item.type.uuid) === -1
                }
                return true;

            })
        }
        if (contentActivitiesFilter.channels !== undefined && contentActivitiesFilter.channels.length>0){
            filteredActivities = (filteredActivities || []).filter((item:PeerActivityType)=>{

                if (item.channel && item.channel.uuid.length >0){
                    return contentActivitiesFilter.channels.indexOf(item.channel.uuid) === -1
                }
                return true;

            })
        }
        if (contentActivitiesFilter.projects !== undefined && contentActivitiesFilter.projects.length>0){
            filteredActivities = (filteredActivities || []).filter((item:PeerActivityType)=>{

                if (item.channel && item.channel.project && item.channel.uuid.length>0){
                    return contentActivitiesFilter.projects.indexOf(item.channel.project.uuid) === -1
                }
                return true;

            })
        }


        if (filteredActivities !== undefined && filteredActivities.length>0) {
            setActivities([...filteredActivities]);
        } else {
            setActivities([]);
        }
    }

    useEffect(() => {

        filterActivities();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[
        contentActivitiesFilter?.projects,
        contentActivitiesFilter?.modes,
        contentActivitiesFilter?.types,
        contentActivitiesFilter?.channels,
    ]);

    // ---- Navigation (all three boards share these; sourced from the period hook) ----
    const boardPrev = () => period.prev();
    const boardNext = () => period.next();
    const boardToday = () => period.today();
    const boardChangeView = (view: string) => period.changeView(view);
    const boardOpenDay = (day: Date) => {
        period.gotoDate(day);
        period.changeView('timeGridDay');
    };

    const boardEditActivity = (activity: PeerActivityType) => {
        const item: PeerActivityType = {...activity};
        if (item.uuid && item.uuid.length > 0) {
            dispatch(setEditPeerActivityItems([item]));
            dispatch(showPeerActivityEditModal());
        }
    };

    // Drag a post to another day column → reschedule to that day, keeping its time of day.
    const boardReschedule = (uuid: string, targetDay: Date) => {
        const activity = (activities || []).find((a) => a.uuid === uuid);
        if (!activity) return;
        const orig = new Date(activity.activeFrom || activity.start);
        const nd = new Date(targetDay);
        nd.setHours(orig.getHours(), orig.getMinutes(), 0, 0);
        const iso = formatISO(new UTCDate(nd));
        const updated: PeerActivityType = {...activity, activeFrom: iso, start: iso, isCheckMedia: false};
        // Optimistic move so the card jumps columns immediately.
        setActivities((prev) => (prev || []).map((a) => (a.uuid === uuid ? updated : a)));
        dispatch(dontSetReloadAfterAction());
        dispatch(onUpdatePeerActivityItems(updated));
    };

    // Week board: the Monday-start week containing the cursor.
    const boardWeekStart = startOfWeek(period.cursor, {weekStartsOn: 1});

    // Day view (feature 006): managed channels → columns; the active day is the cursor.
    const managedDayChannels = ((peerChannels?.items || []) as ContentPeerChannelType[]).filter((c: any) =>
        c.isManaged && c.connector?.isConnected &&
        (Object.values(ContentConnectorSocialCalendar) as string[]).includes(c.connector?.handler?.type));
    const boardDay = period.cursor;
    const boardAddAt = (channelUuid: string, d: Date, time: {h: number; m: number}) => {
        const nd = new Date(d);
        nd.setHours(time.h, time.m, 0, 0);
        handleNewActivity(nd.getTime() / 1000, PeerActivityModeCode.ACTIVITY, channelUuid);
    };

    // Drop an idea from the ideas sidebar onto a calendar day → open a post composed from that idea,
    // pre-dated to the drop day (recovers the removed FullCalendar handleExternalDrop create-from-idea
    // flow). The idea's uuid is carried by the native dragstart in ExternalViewItems; the boards'
    // day cells/columns invoke this with the uuid + the target Date.
    const boardIdeaDrop = (uuid: string, date: Date) => {
        const idea = (peerActivityIdeas || []).find((item: PeerActivityType) => item.uuid === uuid);
        if (idea?.uuid && idea.uuid.length > 0) {
            const d = new Date(date);
            d.setHours(12, 0, 0, 0); // noon, same convention as boardAddOnDay for a pre-dated post
            const iso = formatISO(d);
            const item: PeerActivityType = {...idea, activeFrom: iso, start: iso};
            dispatch(setShowMoreChannels());
            dispatch(setEditPeerActivityItems([item]));
            dispatch(showPeerActivityEditModal());
        }
    };

    // Create a post pre-set to a given day (month/week "add on day"); reuse across boards.
    const boardAddOnDay = (day: Date) => {
        const d = new Date(day);
        d.setHours(12, 0, 0, 0); // noon so the pre-dated post isn't reset to "now" for a future day
        handleNewActivity(d.getTime() / 1000, PeerActivityModeCode.ACTIVITY);
    };
    const boardDuplicate = (activity: PeerActivityType) => dispatch(copyActivity({peerActivity: activity}));
    const boardDelete = (activity: PeerActivityType) => dispatch(removeActivity(activity));
    // Retry a failed post by opening it in the editor (where the publish action lives).
    const boardRetry = (activity: PeerActivityType) => boardEditActivity(activity);

    const isMonth = period.viewId === 'dayGridMonth';
    const isBoard = period.viewId === 'timeGridWeek';
    const isDay = period.viewId === 'timeGridDay';

  return (
      <div className="calendarContainer position-relative">
      {isMonth &&
          <MonthPostsBoard
              activities={activities || []}
              cursor={period.cursor}
              language={i18n.language}
              t={t}
              onPrev={boardPrev}
              onNext={boardNext}
              onToday={boardToday}
              onChangeView={boardChangeView}
              onToggleIdeas={toggleIdeasBlock}
              onEdit={boardEditActivity}
              onDuplicate={boardDuplicate}
              onDelete={boardDelete}
              onRetry={boardRetry}
              onReschedule={boardReschedule}
              onAddOnDay={boardAddOnDay}
              onOpenDay={boardOpenDay}
              onIdeaDrop={boardIdeaDrop}
              groups={variantGroups}
              onOpenGroup={boardOpenGroup}
          />
      }
      {isBoard &&
          <WeekPostsBoard
              activities={activities || []}
              weekStart={boardWeekStart}
              language={i18n.language}
              t={t}
              onPrev={boardPrev}
              onNext={boardNext}
              onToday={boardToday}
              onChangeView={boardChangeView}
              onToggleIdeas={toggleIdeasBlock}
              onEdit={boardEditActivity}
              onReschedule={boardReschedule}
              onAddOnDay={boardAddOnDay}
              onOpenDay={boardOpenDay}
              onDuplicate={boardDuplicate}
              onDelete={boardDelete}
              onRetry={boardRetry}
              onIdeaDrop={boardIdeaDrop}
              groups={variantGroups}
              onOpenGroup={boardOpenGroup}
          />
      }
      {isDay &&
          <DayChannelBoard
              activities={activities || []}
              day={boardDay}
              channels={managedDayChannels}
              language={i18n.language}
              t={t}
              onPrev={boardPrev}
              onNext={boardNext}
              onToday={boardToday}
              onChangeView={boardChangeView}
              onToggleIdeas={toggleIdeasBlock}
              onEdit={boardEditActivity}
              onDuplicate={boardDuplicate}
              onDelete={boardDelete}
              onRetry={boardRetry}
              onAddAt={boardAddAt}
              onIdeaDrop={boardIdeaDrop}
              groups={variantGroups}
              onOpenGroup={boardOpenGroup}
          />
      }
      {openGroup &&
          <VariantGroupModal
              t={t}
              groupUuid={openGroup.uuid}
              createAt={openGroup.createAt}
              channels={managedDayChannels.map((c: any) => ({
                  uuid: c.uuid, name: c.name, network: c.connector?.handler?.code, modes: channelModes(c),
                  avatar: c.avatar || null, handlerUuid: c.connector?.handler?.uuid,
              }))}
              limitFor={(channel, mode, hasMedia) => textLimit(contentConnectorDataParam?.items, channel, mode, hasMedia)}
              onClose={() => setOpenGroup(null)}
              onOpenInEditor={(post: PeerActivityType) => {
                  setOpenGroup(null);
                  dispatch(setEditPeerActivityItems([post]));
                  dispatch(showPeerActivityEditModal());
              }}
          />}
      </div>
  );
};
export default Calendar;
